export default function calculateMonthWorkingTime(shifts) {
    let totalMinutes = 0;

    (shifts || []).forEach((shift) => {
        if (!shift || shift.is_ignored === true) return;
        if (!shift.duration_working) return;

        const { hours, minutes } = shift.duration_working;
        totalMinutes += (hours || 0) * 60 + (minutes || 0);
    });

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    if (minutes === 0) return hours + " Std.";

    return hours + " Std. " + minutes + " Min.";
}
